import { render, staticRenderFns } from "./SampleTypeSelector.vue?vue&type=template&id=0951edc7"
import script from "./SampleTypeSelector.vue?vue&type=script&lang=js"
export * from "./SampleTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports